module.exports = __webpack_public_path__ + "img/bg_pic7.da5d738e.png";